import {Component, EventEmitter, HostListener, Input, Output, TemplateRef, ViewChild, ViewChildren,} from '@angular/core';
import {Columns, Config, Event} from '../..';
import {StyleService} from '../../services/style.service';

@Component({
    selector: '[table-thead]',
    templateUrl: './thead.component.html',
    // changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [StyleService],
    standalone: false
})
export class TableTHeadComponent {
  public menuActive = false;
  public openedHeaderActionTemplate: string | null = null;
  public startOffset;
  public onSelectAllBinded = this.onSelectAll.bind(this);

  @Input() config: Config;
  @Input() columns: Columns[];
  @Input() sortKey;
  @Input() sortState;
  @Input() selectAllTemplate;
  @Input() filtersTemplate;
  @Input() filterTemplate;
  @Input() isAllSelected: boolean;
  @Input() additionalActionsTemplate: TemplateRef<void>;
  @Output() readonly filter = new EventEmitter<Array<{ key: string; value: string }>>();
  @Output() readonly order = new EventEmitter<Columns>();
  @Output() readonly selectAll = new EventEmitter<void>();
  @Output() readonly event = new EventEmitter<{ event: string; value: any; data?: any }>();
  @ViewChild('th') private th;
  @ViewChildren('headerDropdown') headerDropdown;
  @ViewChild('additionalActionMenu') additionalActionMenu;

  constructor(public readonly styleService: StyleService) {
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: any): void {
    if (
      this.additionalActionMenu &&
      !this.additionalActionMenu.nativeElement.contains(targetElement)
    ) {
      this.menuActive = false;
    }

    // if click outside the header then close opened Header Action Template
    if (
      this.openedHeaderActionTemplate &&
      // if no header have the clicked point
      !this.headerDropdown.toArray().some((ref) => ref.nativeElement.contains(targetElement))
    ) {
      this.openedHeaderActionTemplate = null;
    }
  }

  getColumnDefinition(column: Columns): boolean {
    return column.searchEnabled;
  }

  orderBy(column: Columns): void {
    if (this.isOrderEnabled(column)) {
      this.order.emit(column);
    }
  }

  isOrderEnabled(column: Columns): boolean {
    const columnOrderEnabled = column.orderEnabled === undefined ? column.searchEnabled : !!column.orderEnabled;
    return this.config.orderEnabled && columnOrderEnabled;
  }

  onSearch($event: { key: string; value: string }): void {
    this.filter.emit([$event]);
  }

  getColumnWidth(column: any): string | null {
    if (column.width) {
      return column.width;
    }
    return this.config.fixedColumnWidth ? 100 / this.columns.length + '%' : null;
  }

  onSelectAll(): void {
    this.selectAll.emit();
  }

  onMouseDown(event: MouseEvent, th: HTMLTableCellElement): void {
    if (!this.config.resizeColumn) {
      return;
    }
    this.th = th;
    this.startOffset = th.offsetWidth - event.pageX;
  }

  onMouseMove(event: MouseEvent): void {
    if (!this.config.resizeColumn) {
      return;
    }
    if (this.th && this.th.style) {
      this.setWidth(this.th, this.startOffset + event.pageX);
      this.th.style.cursor = 'col-resize';
      this.clearSelection();
    }
  }

  onMouseUp(event: MouseEvent): void {
    if (!this.config.resizeColumn) {
      return;
    }
    if (this.th?.style) {
      this.trySave();
    }
  }

  trySave() {
    if (this.th.style.width) {
      this.event.emit({
        event: Event.onColumnResize,
        value: event,
        data: {
          key: this.th.getAttribute('data-key'),
          width: this.th.style.width,
        }
      });
    }

    this.clearSelection();
    this.th.style.cursor = 'default';
    this.th = undefined;
  }

  onDblClickResizer(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;

    if (targetElement && targetElement.classList.contains('ngx-table__column-resizer') && targetElement.getAttribute('data-index') != '') {
      this.setMaxColumnWidth(targetElement);
      this.th = targetElement.parentElement;
      this.trySave();
    }
  }

  showHeaderActionTemplateMenu(column: Columns): void {
    if (!column.headerActionTemplate) {
      console.error('Column [headerActionTemplate] property not defined');
    }
    if (this.openedHeaderActionTemplate === column.key) {
      this.openedHeaderActionTemplate = null;
      return;
    }
    this.openedHeaderActionTemplate = column.key;
  }

  showMenu(): void {
    if (!this.additionalActionsTemplate) {
      console.error('[additionalActionsTemplate] property not defined');
    }
    this.menuActive = !this.menuActive;
  }

  @HostListener('window:mouseup', ['$event'])
  onMouseUpWindow(event: MouseEvent) {
    this.onMouseUp(event);
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMoveWindow(event: MouseEvent) {
    if (this.th) {
      this.onMouseMove(event);
    }
  }

  clearSelection() {
    try {
      if (window.getSelection) {
        if (window.getSelection().empty) {
          window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) {
          window.getSelection().removeAllRanges();
        }
      }
    } catch (e) {
    }
  }

  setMaxColumnWidth(resizer: HTMLElement) {
    const table = resizer.closest('table');
    let columnIndex = Number(resizer.getAttribute('data-index'));
    if (this.config.checkboxes || this.config.radio) {
      columnIndex += 1;
    }

    const rows = table.querySelectorAll('tr');

    const measurer = document.createElement('span');
    measurer.style.visibility = 'hidden';
    measurer.style.whiteSpace = 'nowrap';
    document.body.appendChild(measurer);

    let maxWidth = 0;
    rows.forEach(row => {
      const cell = row.cells[columnIndex];
      if (cell) {
        const styles = window.getComputedStyle(cell);
        measurer.style.font = styles.font;
        measurer.textContent = cell.textContent.trim();

        maxWidth = Math.max(maxWidth, measurer.offsetWidth + 15);
      }
    });

    document.body.removeChild(measurer);
    if (maxWidth > 10) {
      this.setWidth(resizer.closest('th'), Math.min(700, maxWidth));
    }
  }

  setWidth(th, width) {
    th.style.width = width + 'px';
    th.style.minWidth = width + 'px';
  }

}
